var _rect, _path, _g, _g2, _g3, _g4, _g5, _rect2, _rect3, _rect4, _rect5, _g6, _rect6, _rect7, _g7, _rect8, _rect9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectCardIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 100,
    viewBox: "0 0 92 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.8465,
    y: 62.4754,
    width: 49.3471,
    height: 31.6627,
    rx: 2.75156,
    fill: "url(#paint0_radial_296_663)",
    stroke: "url(#paint1_linear_296_663)",
    strokeWidth: 0.611458
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1942 98.7452C15.729 99.2066 16.0557 100 16.7109 100H74.0026C74.6123 100 74.9561 99.2994 74.5829 98.8172L73.0955 96.8952C72.9565 96.7156 72.7422 96.6105 72.5152 96.6105H18.649C18.4555 96.6105 18.2698 96.6869 18.1324 96.8232L16.1942 98.7452Z",
    fill: "#00FD8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 13.0946,
    y: 31.0024,
    width: 15.386,
    height: 14.2416,
    rx: 2.21056,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 14.6719,
    y: 32.4527,
    width: 12.2314,
    height: 11.3413,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 38.1644,
    width: 17.8318,
    height: 16.5055,
    rx: 2.21056,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 39.9438,
    y: 1.6319,
    width: 14.273,
    height: 13.2414,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 20.4321,
    y: 12.2292,
    width: 13.5516,
    height: 12.5436,
    rx: 2.21056,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 21.8579,
    y: 13.5428,
    width: 10.7002,
    height: 9.91625,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 0.865479,
    y: 18.9553,
    width: 11.7172,
    height: 10.8457,
    rx: 2.21056,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 2.13959,
    y: 20.1324,
    width: 9.16905,
    height: 8.4912,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 38.1644,
    y: 24.4583,
    width: 14.1631,
    height: 13.1096,
    rx: 2.21056,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 39.6407,
    y: 25.8174,
    width: 11.2106,
    height: 10.3913,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 2.0885,
    y: 49.5281,
    width: 14.5658,
    height: 14.0635,
    rx: 2.21056,
    fill: "#BFBFBF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 3.48371,
    y: 50.9944,
    width: 11.615,
    height: 10.7677,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 60.1769,
    y: 34.853,
    width: 13.8683,
    height: 12.8367,
    rx: 2.21056,
    fill: "#BFBFBF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 61.6288,
    y: 36.1905,
    width: 10.9645,
    height: 10.1622,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 59.5654,
    y: 15.2864,
    width: 12.5471,
    height: 11.6138,
    rx: 2.21056,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 60.908,
    y: 16.5255,
    width: 9.86173,
    height: 9.13586,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 74.2405,
    y: 48.3052,
    width: 13.8683,
    height: 12.8367,
    rx: 2.21056,
    fill: "#BFBFBF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 75.973,
    y: 50.0377,
    width: 10.3261,
    height: 9.85057,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 76.6863,
    y: 23.8469,
    width: 15.0318,
    height: 13.9137,
    rx: 2.21056,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 78.5382,
    y: 25.699,
    width: 11.2438,
    height: 10.7283,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32.0498,
    y: 48.9167,
    width: 27.5156,
    height: 26.2927,
    rx: 2.21056,
    fill: "#1A1920"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 34.1899,
    y: 51.0567,
    width: 23.2354,
    height: 22.0125,
    rx: 1.90483,
    stroke: "#C8C8C8",
    strokeWidth: 0.611458
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_296_663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.8232 31.0601) rotate(25.2724) scale(238.676 891.984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259615,
    stopColor: "#040209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FD8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_296_663",
    x1: 12.4015,
    y1: 44.663,
    x2: 18.7485,
    y2: 97.6506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFDA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectCardIcon3);
export default __webpack_public_path__ + "static/media/RectCardIcon3.5e99f903764be959e15d8c8d2f67de06.svg";
export { ForwardRef as ReactComponent };